const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
require('./AssetsNavigator.scss');

const AssetsNavigator = ({ history, children, next, prev }) => (
    <div className="funds__pagination">
        <div className="pagination__actions">
            <span className="actions--left">
                {prev && <div onClick={() => history.push(prev)} className="actions--left assets-navigator__button-prev"></div>}
            </span>
            <p className="actions--text">{children}</p>
            <span className="actions--right">
                {next && <div onClick={() => history.push(next)} className="actions--right assets-navigator__button-next"></div>}
            </span>
        </div>
    </div>
);


AssetsNavigator.propTypes = {
    history: PropTypes.object.isRequired,
    children: PropTypes.node,
    next: PropTypes.string,
    prev: PropTypes.string,
};


module.exports = withRouter(AssetsNavigator);
